import A11yDialog from "a11y-dialog";

const modals = document.querySelectorAll('.modal');
const videoModals = document.querySelectorAll('.video-modal');

modals?.forEach(modal => {
    let dialog = new A11yDialog(modal);
    dialog.on('hide', function (event) {
        const container = event.target;
        const iframe = container.querySelector('iframe');
        if (!iframe) {
            return;
        }
        let src = iframe.getAttribute('src');
        iframe.removeAttribute('loading'); // lazy loading will prevent the frame from loading again
        iframe.setAttribute('src', '');
        iframe.setAttribute('src', src);
    });
})

videoModals?.forEach(modal => {
    const iframe = modal.querySelector('iframe');
    if (!iframe) {
        return;
    }
    const label = modal.querySelector('p.visually-hidden');
    label.textContent = iframe.getAttribute('title');
});
